import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import ErrorMssg from "../../Components/ErrorMssg/ErrorMssg";
import LanguageSelector from "../../Components/Language-selector";
import { useLibyaSignupLogic } from "../SignUp/libya/useLibyaSignupLogic";
import "./Marketing4Page.css";

function SpeedLines({ side = "L" }) {
  return (
    <div
      className={`mkt4-speed mkt4-speed--${side}`}
      aria-hidden
    />
  );
}

function FighterRival({ variant, gid }) {
  const uid = `m4g-${gid}`;
  const uid2 = `m4c-${gid}`;
  const body = (
    <>
      <circle cx="78" cy="40" r="24" fill={variant === "A" ? `url(#${uid})` : `url(#${uid2})`} filter={`url(#${uid}f)`} />
      <path
        d="M55 65 L30 80 L20 100 L40 120 L60 110 L65 90 L50 200 L75 210 L90 200 L100 100 L120 60 L100 50 Z"
        fill={variant === "A" ? `url(#${uid})` : `url(#${uid2})`}
      />
      <path
        d="M100 100 L140 70 L150 90 L120 120 Z"
        fill={variant === "A" ? `url(#${uid})` : `url(#${uid2})`}
      />
    </>
  );
  return (
    <svg className="mkt4-rivalfg" viewBox="0 0 120 220" aria-hidden>
      <defs>
        <linearGradient id={uid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fca5a5" />
          <stop offset="0.4" stopColor="#dc2626" />
          <stop offset="1" stopColor="#450a0a" />
        </linearGradient>
        <linearGradient id={uid2} x1="1" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#93c5fd" />
          <stop offset="0.45" stopColor="#2563eb" />
          <stop offset="1" stopColor="#1e1b4b" />
        </linearGradient>
        <filter id={`${uid}f`}>
          <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor={variant === "A" ? "#f87171" : "#38bdf8"} floodOpacity="0.55" />
        </filter>
      </defs>
      {variant === "A" ? body : <g transform="scale(-1,1) translate(-120,0)">{body}</g>}
    </svg>
  );
}

/**
 * /marketing4 — مواجهة وتنافس (ساحة منقسمة، صدام، سجل تحدي) وليس مجرّد ألوان
 */
const Marketing4Page = () => {
  const { t, i18n } = useTranslation();
  const {
    errMsg,
    msisdn,
    otp,
    setOtp,
    isOTP,
    setIsOTP,
    isLoading,
    isValidMsisdn,
    onSubmit,
    onVerifyOtp,
    allowOnlyNumbers,
    handleMsisdnChange,
  } = useLibyaSignupLogic();

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n, i18n.language]);

  return (
    <div className="mkt4" dir="ltr">
      <div className="mkt4-slab mkt4-slab--ember" aria-hidden />
      <div className="mkt4-slab mkt4-slab--frost" aria-hidden />
      <div className="mkt4-clash" aria-hidden />
      <div className="mkt4-grit" aria-hidden />
      <SpeedLines side="L" />
      <SpeedLines side="R" />

      <div className="mkt4-rivals" aria-hidden>
        <div className="mkt4-zone mkt4-zone--a">
          <span className="mkt4-corner mkt4-corner--a">RED CORNER</span>
          <FighterRival variant="A" gid="a" />
        </div>

        <div className="mkt4-versus" aria-hidden>
          <div className="mkt4-versus-burst" />
          <div className="mkt4-vs">VS</div>
          <div className="mkt4-tension" title="">
            <div className="mkt4-tension__left" />
            <div className="mkt4-tension__diamond" />
            <div className="mkt4-tension__right" />
          </div>
        </div>

        <div className="mkt4-zone mkt4-zone--b">
          <span className="mkt4-corner mkt4-corner--b">BLUE CORNER</span>
          <FighterRival variant="B" gid="b" />
        </div>
      </div>

      <div className="mkt4-center" dir={i18n.dir()}>
        <div className="mkt4-bar">
          <p className="mkt4-tagline">WINNER TAKES ALL</p>
          <LanguageSelector />
        </div>

        {!isOTP && (
          <>
            <div className="mkt4-head">
              <h1 className="mkt4-h1">
                {t("SubscribeNowText")}
                <span className="mkt4-crack" aria-hidden />
              </h1>
              <p className="mkt4-lead cptpl_service d-block">
                {t(
                  "compete in tournaments and track their performance through leaderboards. It offers a space for both casual and competitive players across various games."
                )}
              </p>
              <div className="mkt4-logo-wrap">
                <img
                  className="mkt4-logo servImg cptpl_logo"
                  src={logo}
                  alt="Gamer Club"
                />
              </div>
            </div>

            <div className="mkt4-scroll">
              <div className="mkt4-scroll-rip" aria-hidden />
              <div className="mkt4-stamp">LIVE</div>
              <h2 className="mkt4-scroll-h">{t("Enteryourmobilenumber")}</h2>
              <form onSubmit={onSubmit} className="mkt4-f">
                <div className="mkt4-row" dir="ltr">
                  <input
                    value="218"
                    readOnly
                    className="form-control mkt4-pfx"
                  />
                  <input
                    type="text"
                    placeholder={t("Enteryourmobilenumber")}
                    className="form-control mkt4-inp"
                    value={msisdn}
                    onChange={handleMsisdnChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    autoComplete="tel-national"
                  />
                </div>
                {msisdn.length > 0 && !isValidMsisdn && (
                  <small className="mkt4-err">
                    {msisdn.startsWith("218")
                      ? t(
                          "Mobile number must be 12–13 digits when starting with 218"
                        )
                      : t("Mobile number must be 9 digits")}
                  </small>
                )}
                <button
                  type="submit"
                  className="mkt4-cta cptpl_subscribe"
                  id="cta_button"
                  disabled={isLoading || !isValidMsisdn}
                >
                  {isLoading ? t("Processing") : t("subscribe")}
                </button>
              </form>
            </div>

            <div className="mkt4-foot" style={{ direction: "rtl" }}>
              <p className="price_text price_title cptpl_price">
                {t("New_subscribers_weekly_ts_libyaF")}
                <br />
                {t("New_subscribers_monthly_ts_libyaF")}
              </p>
              <p className="cptpl_terms">
                {t("New_subscribers_ts_libya_condition")}
              </p>
              <p>
                <a href="/terms">{t("terms_of_service")}</a>
                {" · "}
                <a href="/privacy">{t("privacy_policy")}</a>
              </p>
            </div>
          </>
        )}

        {isOTP && (
          <div className="mkt4-scroll mkt4-scroll--otp">
            <div className="mkt4-scroll-rip" aria-hidden />
            <h2 className="mkt4-otp-t">{t("OTP VERIFICATION")}</h2>
            <p className="mkt4-otp-d">
              {t("Enter the OTP sent to")} — <b>{msisdn}</b>
            </p>
            <form onSubmit={onVerifyOtp} className="mkt4-f">
              <input
                className="form-control mkt4-inp mkt4-otp text-center"
                maxLength="4"
                placeholder={t("EnteryourOTP")}
                value={otp}
                onKeyDown={allowOnlyNumbers}
                onChange={(e) => setOtp(e.target.value)}
                inputMode="numeric"
                autoComplete="one-time-code"
                dir="ltr"
              />
              <button
                type="submit"
                className="mkt4-cta"
                disabled={isLoading || otp.length !== 4}
              >
                {isLoading ? "…" : t("Confirm")}
              </button>
              <button
                type="button"
                className="mkt4-ghost"
                onClick={() => setIsOTP(false)}
              >
                {t("Back")}
              </button>
            </form>
          </div>
        )}

        {errMsg ? (
          <div className="mkt4-msg">
            <ErrorMssg errMsg={errMsg} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Marketing4Page;
